const getters = {
  getMenuList(state) {
    return state.menus;
  },
};
export default getters;
